/* ------------------------------------------------------------------
   Shayra — close the account popup when the customer clicks outside it.

   Shopify's <shopify-account> component opens its panel with
   dialog.showModal() and never sets closedby="any", so the browser's
   native light-dismiss behaviour does not apply: the only ways out were
   the small X and the Escape key.

   A pointerdown that resolves to the <dialog> element itself, at
   coordinates outside the dialog's box, is a click on the backdrop.
   When that happens we click the component's own close button so its
   internal state stays in sync, falling back to dialog.close().
   ------------------------------------------------------------------ */

(() => {
  const wire = (host) => {
    const root = host && host.shadowRoot;
    if (!root || root.shayraOutsideCloseBound) return;

    const dialog = root.querySelector('dialog');
    if (!dialog) return;

    root.shayraOutsideCloseBound = true;

    dialog.addEventListener('pointerdown', (event) => {
      // Clicks inside the panel resolve to an inner element.
      // Only the backdrop resolves to the dialog itself.
      if (event.target !== dialog) return;

      const box = dialog.getBoundingClientRect();
      const inside =
        event.clientX >= box.left &&
        event.clientX <= box.right &&
        event.clientY >= box.top &&
        event.clientY <= box.bottom;
      if (inside) return;

      const closeButton = root.querySelector('#close-button');
      if (closeButton) {
        closeButton.click();
      } else {
        dialog.close();
      }
    });
  };

  const wireAll = () => {
    document.querySelectorAll('shopify-account').forEach(wire);
  };

  wireAll();

  // The component is hydrated asynchronously, so keep looking briefly.
  let tries = 0;
  const timer = setInterval(() => {
    wireAll();
    tries += 1;
    if (tries > 60) clearInterval(timer);
  }, 250);
})();
